import { useEffect, useState } from 'react'
import { Button } from '@/common/ui/button'
import { Modal } from '@/common/ui/modal'
import { AlertTriangle } from 'lucide-react'

interface ProbabilityLowWarningDialogProps {
	isOpen: boolean
	onClose: () => void
	totalProbability: number
}

export const ProbabilityLowWarningDialog: React.FC<
	ProbabilityLowWarningDialogProps
> = ({ isOpen, onClose, totalProbability }) => {
	const [isMounted, setIsMounted] = useState(false)

	useEffect(() => {
		setIsMounted(true)
	}, [])

	if (!isMounted) {
		return null
	}

	return (
		<Modal
			title="⚠️ คำเตือนเปอร์เซ็นต์การออกรางวัล"
			description="เปอร์เซ็นต์การออกรางวัลรวมน้อยกว่า 100%"
			isOpen={isOpen}
			onClose={onClose}
		>
			<div className="space-y-4">
				<div className="flex items-center gap-3 rounded-lg border border-yellow-200 bg-yellow-50 p-4 text-yellow-800 dark:border-yellow-800 dark:bg-yellow-950/20 dark:text-yellow-200">
					<AlertTriangle className="h-6 w-6 flex-shrink-0 text-yellow-600 dark:text-yellow-400" />
					<div className="text-sm">
						<p className="font-bold text-yellow-900 dark:text-yellow-100">
							⚠️ เปอร์เซ็นต์การออกรางวัลไม่ครบ 100%
						</p>
						<p className="mt-1 font-semibold text-yellow-800 dark:text-yellow-200">
							เปอร์เซ็นต์รวมปัจจุบัน: {totalProbability.toFixed(1)}%
						</p>
						<p className="mt-2 leading-relaxed">
							<span className="font-medium">หมายเหตุ:</span>{' '}
							เปอร์เซ็นต์การออกรางวัลรวมน้อยกว่า 100%
							อาจทำให้มีโอกาสที่ผู้เล่นจะไม่ได้รับรางวัลใดๆ
							<br />
							<span className="font-medium">แนะนำ:</span>{' '}
							ปรับแต่งเปอร์เซ็นต์ในแต่ละรางวัลให้มีค่ารวมเท่ากับ 100%
							เพื่อประสบการณ์ที่ดีที่สุด
						</p>
					</div>
				</div>
				<div className="flex w-full items-center justify-end space-x-2 pt-2">
					<Button
						variant="outline"
						onClick={onClose}
						className="border-yellow-300 text-yellow-700 hover:bg-yellow-50 dark:border-yellow-600 dark:text-yellow-300 dark:hover:bg-yellow-950/30"
					>
						เข้าใจแล้ว
					</Button>
				</div>
			</div>
		</Modal>
	)
}
